import React from "react";
import ReactHtmlParser from "react-html-parser";

const NewsTile = (props) => {
  //console.log(props);

  //console.log(props?.state?.language);
  //console.log(props);

  //console.log(props?.state?.language);
  const handleNav = (linkurl, file) => {
    let urlLower = linkurl?.toLowerCase();
    let urlStart = urlLower?.substring(0, 4);
    if (linkurl && linkurl != "null") {
      if (urlStart === "http") {
        window.open(`${urlLower}`, "_blank");
      } else {
        window.open(`//${urlLower}`, "_blank");
      }
    } else if (file && file != "null") {
      window.open(`https://kspace.inovace.in/${file}`, "_blank");
    } else {
      props.viewMore();
    }
  };
  return (
    <div className="news-updates-tiles-container h-100">
      <div className="news-updates-tile-box-container h-100">
        <div className="event-tile-data-container ">
          <div
            className="news-updates-tile-box-title"
            // onClick={() => handleNav(props?.data?.link, props?.data?.file)}
            onClick={() => props.viewMore()}
          >
            {props.lang === "ma" ? props?.data?.title_ma : props?.data?.title}
          </div>
          <div className="content-box">
            <div
              className="event-tile-box-desc"
              style={{
                textAlign: "left",
                height:
                  props?.data?.title.length <= 30
                    ? "253px"
                    : props?.data?.title.length > 20 &&
                      props?.data?.title.length < 70
                      ? "210px"
                      : "133px",
              }}
            >
              {props.lang === "ma"
                ? props?.data?.description_ma &&
                ReactHtmlParser(props?.data?.description_ma)
                : props?.data?.description
                  ? ReactHtmlParser(props?.data?.description)
                  : ""}
            </div>
          </div>
        </div>
        <div className="news-readmore" onClick={() => props.viewMore()} style={{ textAlign: "center" }}>
          Read More{" "}
        </div>
      </div>

    </div>
  );
};

export default NewsTile;
// import React from "react";
// import "./NewsMarquee.css";

// const NewsMarquee = ({ data = [], lang = "en", viewMore }) => {
//   // Duplicate data to avoid visible gaps
//   const repeatedData = [...data, ...data];

//   return (
//     <div className="news-marquee-wrapper">
//       <div className="news-marquee-track">
//         {repeatedData.map((item, index) => (
//           <div
//             key={index}
//             className="news-marquee-item"
//             onClick={() => viewMore(item)}
//           >
//             <div className="news-title">
//               {lang === "ma" ? item.title_ma : item.title}
//             </div>
//             <div className="news-desc">
//               {lang === "ma" ? item.description_ma : item.description}
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default NewsMarquee;
